// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import less from 'less'
Vue.use(less)
import store from './store'
// 清除样式
import './assets/style/reset.css'

// elementui引入
import { Message} from 'element-ui';
Vue.prototype.$message = Message;
// rem适配
import './utils/rem'
// 分页器
import Pagination from '@/components/Pagination'
Vue.component(Pagination.name,Pagination)


Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js